import React from 'react';
import IconType from './iconType';

function AttachIcon({ color = '#424242', height = 20, width = 20 }: IconType) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.875 10C1.875 6.8934 4.3934 4.375 7.5 4.375H14.1667C16.3528 4.375 18.125 6.14721 18.125 8.33333C18.125 10.5195 16.3528 12.2917 14.1667 12.2917H7.38095C6.1153 12.2917 5.08928 11.2657 5.08928 10C5.08928 8.73433 6.1153 7.70833 7.38095 7.70833H13.9286C14.2738 7.70833 14.5536 7.98816 14.5536 8.33333C14.5536 8.6785 14.2738 8.95833 13.9286 8.95833H7.38095C6.80566 8.95833 6.33928 9.42467 6.33928 10C6.33928 10.5753 6.80566 11.0417 7.38095 11.0417H14.1667C15.6624 11.0417 16.875 9.82908 16.875 8.33333C16.875 6.83756 15.6624 5.625 14.1667 5.625H7.5C5.08375 5.625 3.125 7.58376 3.125 10C3.125 12.4162 5.08376 14.375 7.5 14.375H13.9286C14.2738 14.375 14.5536 14.6548 14.5536 15C14.5536 15.3452 14.2738 15.625 13.9286 15.625H7.5C4.3934 15.625 1.875 13.1066 1.875 10Z"
        fill={color}
      />
    </svg>
  );
}

export default AttachIcon;
